/* mc-scroll-to-buybox (+ generic [data-mc-scroll-anchor] links, e.g. #trustpilot-reviews): smooth-scrolls CTA links to the on-page buy box.
   Loaded by snippets/mc-scroll-to-buybox.liquid inside each buy box section. Buy box roots carry [data-mc-buybox] (plus an #buy-box anchor). A link scrolls when it is outside the buy box and:
   - has [data-mc-scroll-buybox] (rendered by the CTA snippets when the link setting is empty or #buy-box), or
   - its href is "#buy-box" / "#mc-buy-box", or
   - it matches the selector in [data-mc-buybox-force] (MC Adv · Buy box scroll section).
   No buy box on the page = links behave normally. Honors prefers-reduced-motion. */
(function () {
  if (window.__mcScrollBB) return; window.__mcScrollBB = true;
  var BAR_SEL = '.shopify-section-group-header-group, .section-header, sticky-header, header, .announcement-bar, .cro-pb, .mc-fo-ann, [data-mc-fo-ann]';
  function box() {
    var b = document.querySelector('[data-mc-buybox]');
    if (b) return b;
    var a = document.getElementById('buy-box') || document.getElementById('mc-buy-box');
    return a ? (a.closest('[data-mc-bb], [data-mc-bbe], [data-mc-bbd], [data-mc-bbc]') || a) : null;
  }
  /* Land on the subscribe & save options (all screen sizes), not the gallery. */
  function target(b) {
    var q = b.querySelector('[id^="buybox-qty"], .mc-bb__offers');
    return q || b;
  }
  function topBars() {
    var h = 0, used = [];
    document.querySelectorAll(BAR_SEL).forEach(function (el) {
      for (var i = 0; i < used.length; i++) if (used[i].contains(el) || el.contains(used[i])) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var t = parseFloat(cs.top);
      if (isNaN(t) || t > 200) return; /* bottom bars have top:auto */
      var r = el.getBoundingClientRect();
      if (r.height <= 0 || r.height > window.innerHeight * 0.4) return;
      used.push(el); h += r.height;
    });
    return h;
  }
  function extra() {
    var f = document.querySelector('[data-mc-buybox-force]');
    var o = f && parseInt(f.getAttribute('data-offset'), 10);
    return isNaN(o) || o == null ? 16 : o;
  }
  function setVar() { document.documentElement.style.setProperty('--mc-scroll-offset', (topBars() + extra()) + 'px'); }
  function wants(a) {
    if (a.hasAttribute('data-mc-scroll-buybox')) return true;
    var h = (a.getAttribute('href') || '').trim();
    if (h === '#buy-box' || h === '#mc-buy-box') return true;
    var f = document.querySelector('[data-mc-buybox-force]');
    var sel = f && f.getAttribute('data-mc-buybox-force');
    if (sel) { try { return a.matches(sel); } catch (e) {} }
    return false;
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    if (a.hasAttribute('data-mc-scroll-anchor')) {
      var id = (a.getAttribute('href') || '').replace(/^#/, '');
      var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var yy = el.getBoundingClientRect().top + window.pageYOffset - topBars() - extra();
      var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, yy), behavior: rm ? 'auto' : 'smooth' });
      try { el.focus({ preventScroll: true }); } catch (err) {}
      return;
    }
    if (!wants(a)) return;
    var b = box();
    if (!b || b.contains(a)) return;
    e.preventDefault();
    var t = target(b);
    var y = t.getBoundingClientRect().top + window.pageYOffset - topBars() - extra();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (!b.hasAttribute('tabindex')) b.setAttribute('tabindex', '-1');
    try { b.focus({ preventScroll: true }); } catch (err) {}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setVar); else setVar();
  window.addEventListener('resize', setVar, { passive: true });
})();
